import React, { ReactElement } from 'react';
import { mapIriToSekciaPredpisu, reformatIri } from 'slovlex-idsk-react-components';
import {
  Text, Button, ModalDialogue, ErrorMessage,
} from 'idsk-react-components';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PredpisSearchModalComponent from '../../../../PredpisSearchModalComponent/PredpisSearchModalComponent';
import iconSourceAdd from '../../../../../../assets/images/icon-source-add.svg';
import iconSourceDelete from '../../../../../../assets/images/icon-source-delete.svg';
import { useClient } from '../../../../../context/ClientStatusContext';
import { fetchPredpis } from '../../../../../client/external/indexer/predpisClient';
import { Predpis } from '../../../../../model/indexer/Predpis';
import PouzitiePredpis from '../../../../../model/PouzitiePredpis';
import { useSecurityContext } from '../../../../../context/SecurityContext';

interface Props {
  setItemList: (data: PouzitiePredpis[]) => void;
  setPouzitiePredpis;
  itemId: number;
  itemList: Array<PouzitiePredpis>;
  pouzitiePredpis: PouzitiePredpis;
  error?: string;
}

const VybratPredpis = ({
  setItemList,
  setPouzitiePredpis,
  itemId,
  itemList = [],
  pouzitiePredpis,
  error = null,
}: Props): ReactElement => {
  const {
    wrapClient: fetchPredpisClient,
  } = useClient(fetchPredpis);

  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };

  const updateVybranyPredpis = async (_: string, url: string): Promise<void> => {
    const { cesta, iri } = reformatIri(url);
    const { data } = await fetchPredpisClient(iriToCislo(iri));
    const popis = buildPopis(data, cesta, iri);
    updateValues(url, popis);

    window.parent.postMessage(
      {
        type: 'iframe-to-parent-modal-dialogue-close',
      },
      '*',
    );
  };

  const updateValues = (url: string, popis: string): void => {
    setPouzitiePredpis(prevState => ({ ...prevState, url, popis }));
    const newFormValues = [...itemList];
    newFormValues[itemId] = { ...pouzitiePredpis, url, popis };
    setItemList(newFormValues);
  };

  const iriToCislo = (iri: string): string => {
    const parts = iri.split('/');
    return `${parts[4]}/${parts[3]}`;
  };
  const buildPopis = (
    predpis: Predpis,
    cesta: string,
    iri: string,
  ): string => `${predpis.cislo} ${mapIriToSekciaPredpisu(cesta, iri)} - ${predpis.nazov}`;

  if (pouzitiePredpis.url && pouzitiePredpis.popis) {
    return (
      <>
        <Text>{pouzitiePredpis.popis}</Text>
        <Button
          size="large"
          buttonStyle="third"
          iconBefore={iconSourceDelete}
          onClick={() => {
            updateValues(undefined, undefined);
          }}
        >
          Zmazať právny predpis
        </Button>
      </>
    );
  }

  return (
    <>
      {error && <ErrorMessage message={error} />}
      <ModalDialogue
        title=""
        openModalDialogueBtn={(
          <Button
            size="large"
            buttonStyle="third"
            iconBefore={iconSourceAdd}
            onClick={() => {
              window.parent.postMessage({
                type: 'iframe-to-parent-modal-dialogue-open',
              }, '*');
            }}
          >
            Vybrať právny predpis
          </Button>
        )}
      >
        <HelmetProvider>
          <Helmet>
            <script src={`${process.env.REACT_APP_SUBPATH}js/jquery.min.js`} type="application/javascript" />
          </Helmet>
          <PredpisSearchModalComponent setUpdateVybranyPredpis={updateVybranyPredpis} headers={headers} />
        </HelmetProvider>
      </ModalDialogue>
    </>
  );
};

export default VybratPredpis;
